
import { Ajax } from "@story/story_assets/ajax";
import { onDocumentReady } from "@story/story_assets";


; (function () {

	// *************************************************************************
	// Privátní rozhraní modulu
	// *************************************************************************

	var URL = "/vyhledat/autocomplete";

	//
	// Vlastní našeptávání výsledků vyhledávání.
	//
	function Autocomplete() {
		var input = null;
		var form = null;
		var dialog = null;

		function createDialog() {
			if (dialog) {
				return;
			}

			dialog = document.createElement("div");
			dialog.classList.add("autocomplete-results");

			form.appendChild(dialog);
		}


		function destroyDialog() {
			if (dialog) {
				dialog.remove();
				dialog = null;
			}
		}

		function onSearch(response, data, u) {
			createDialog();
			dialog.innerHTML = response.response;
		}

		function onError(response) {
		}

		function search(query) {
			// Strip.
			query = query.replace(/^\s+|\s+$/g, "");

			if (0 < query.length) {
				Ajax.post(URL, { q: query }).then(onSearch, onError);
			}
			else {
				destroyDialog();
			}
		}

		function onFocus() {
			search(input.value);
		}

		function onKeyUp() {
			search(input.value);
		}

		function onBlur() {
		}

		function onClickOutside(event) {
			var target = event.target;
			if (!target.closest("#search-field") && !target.closest(".autocomplete-results")) {
				destroyDialog();
			}
		}

		function constructor() {
			input = document.querySelector("#search-field");
			form = input.closest("form");
			if (!input || !form) {
				return;
			}

			input.addEventListener("focus", onFocus);
			input.addEventListener("blur", onBlur);

			function delay(callback, ms) {
				var timer = 0;
				return function () {
					var context = this, args = arguments;
					clearTimeout(timer);
					timer = setTimeout(function () {
						callback.apply(context, args);
					}, ms || 0);
				};
			}

			input.addEventListener("keyup", delay(onKeyUp, 100));
			document.addEventListener("click", onClickOutside);
		}

		constructor();
	}


	// *************************************************************************
	// Veřejné rozhraní modulu
	// *************************************************************************


	onDocumentReady(function () {
		Autocomplete();
	});


}());